import * as config from '../../../wips.config.js';
import { ContextService } from '../../../services/context_service';
import { IDs } from '../../../helpers/IDs';
import { lazyInject } from '../../../services/inversify';
import * as React from 'react';
import { Routing } from '../../../helpers/Routing';
import { RoutingIDs } from '../../../helpers/RoutingAdminIDs';
import { StructureService } from '../../../services/structure_service';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { TriggerService } from '../../../core/trigger/trigger_service';
import { WFormsTableWrapper } from '../../../core/table/WFormsTableWrapper';

interface DatenverwaltungKatalogeProps extends React.ClassAttributes<any> {
    data: any;
    onRoutingChange: (routing: any) => void;
    routing: any;
}

interface DatenverwaltungKatalogeState {
    tabIndex: number;
}

export class DatenverwaltungKataloge extends React.Component<DatenverwaltungKatalogeProps, DatenverwaltungKatalogeState> {

    constructor(props: any) {
        super(props);
        this.state = {
            tabIndex: null
        };
    }

    @lazyInject(ContextService) private contextService: ContextService;
    @lazyInject(StructureService) private structureService: StructureService;
    @lazyInject(TriggerService) private triggerService: TriggerService;

    private basisKatalog: any[] = [];
    private devFeatures: boolean = config.devFeatures || false;
    private disabled: string[] = [];
    private notice: string[] = ['anlagen_eigenstrom_typen', 'maschinen_typen', 'fahrzeuge_typen'];
    private prefix: string = 'admin.tab.datenverwaltung'/*'admin.tab.datenverwaltung.kataloge'*/;
    private rechte: any = {};
    private tabName: string = RoutingIDs.TABS_DATENVERWALTUNG_KATALOGE;
    private tabIndex: string = `${this.tabName}Index`;
    private tabRoutings: any[] = [];
    private tabs: string[] = []; // Reitereihenfolge beachten
    private warning: string[] = [
        'energiedaten_waerme_energietraeger', 'energiedaten_waerme_heizung_elektrisch', 'energiedaten_waerme_einheiten',
        'energiedaten_wasser_einheiten', 'himmelsrichtungen', 'energiedaten_kraftstoff_energietraeger', 'standort_typen'
    ];

    componentDidMount(): void {
        this.setBasisKatalog();
        (new Routing(this)).init((rechte: any, tabIndex: number) => {
            this.rechte = rechte || {};
            this.setTabIndex(tabIndex, this.tabRoutings[tabIndex]);
        });
    }

    componentDidUpdate(prevProps: any): void {
        if (JSON.stringify(this.props.routing) !== JSON.stringify(prevProps.routing)) {
            this.checkRouting();
        }
    }

    checkRouting(): void {
        const routing: any = this.props.routing || {};
        if (typeof (routing.path || {})[this.tabName] === 'undefined') {
            return;
        }
        // this.setTabIndex(routing.path[this.tabName], routing, () => {
        //     if (routing.path.terminateOn === this.tabName) {
        //         this.props.onRoutingChange({});
        //     }
        // });
        if (this.state.tabIndex === routing.path[this.tabName]) {
            if (routing.path.terminateOn === this.tabName) {
                this.props.onRoutingChange({});
            }
        } else {
            this.setTabIndex(routing.path[this.tabName], routing);
        }
    }

    render(): JSX.Element[] {
        if (this.state.tabIndex === null) {
            return null;
        }

        return [
            <div key='hinweis' style={{ fontSize: 12, fontStyle: 'italic', backgroundColor: '#feb', padding: 10 }}>
                <b>Wichtiger Hinweis:</b><br />
                Manche der Kataloge sind kritisch für den Betrieb des E-Tools.<br />
                Änderungen an rot dargestellten Katalogen können dazu führen, dass sowohl die Dateneingabe als auch die Berechnung und
                Datenausgabe beeinträchtig werden oder gar nicht mehr funktionieren.<br />
                Änderungen an gelb markierten Katalogen erfordern ggf. weitere Anpassungen im Programmcode, z.B. bei Filtern o.Ä.
                Grundsätzlich gilt: Wenn Optionen entfernt werden, die bereits gewählt wurden, geht diese Auswahl in den entsprechenden
                Datensätzen dauerhaft verloren.
            </div>,
            <Tabs
                key='tabs'
                className='tabs-admin-datenverwaltung'
                selectedIndex={this.state.tabIndex}
                onSelect={(tabIndex, lastIndex, event) => this.setTabIndex(tabIndex, this.tabRoutings[tabIndex])}
            >
                <TabList>
                    {this.renderTabs()}
                </TabList>
                {this.renderTabPanels()}
            </Tabs>
        ];
    }

    renderTabPanels(): JSX.Element[] {
        return this.basisKatalog.map((katalog: any, index: number) =>
            <TabPanel key={`panel-${index}`}>
                {this.rechte[this.tabs[index]] &&
                    <WFormsTableWrapper
                        entity={katalog.entity}
                        module={IDs.MOD_ETOOL_ADMIN}
                        actions={['edit', 'add', 'delete']}
                        customClass='Custom-ETA'
                        formLayout='flowV2'
                        onSaveDone={() => this.triggerService.fire('reload', katalog.entity)}
                        showColumnsHelp
                    />
                }
            </TabPanel>
        );
    }

    renderTabs(): JSX.Element[] {
        return this.basisKatalog.map((katalog: any, index: number) =>
            <Tab
                key={`tab-${index}`}
                ref={(ref: any) => this.setTabStyle(index, katalog.entity, ref)}
                disabled={!this.rechte[this.tabs[index]]}
            >
                {katalog.titel|| null}
            </Tab>
        );
    }

    setBasisKatalog(): void {
        const structures: any = this.structureService.getStructureAllByModul(IDs.MOD_ETOOL_ADMIN) || {};
        let disabled: string[] = [];

        if (!this.devFeatures) {
            disabled = [IDs.ENT_KONTAKT_THEMEN];
        }

        Object.keys(structures).forEach((key: string) => {
            const basis_katalog: boolean = (structures[key].SRC || {}).basis_katalog || false;
            const entity: string = (structures[key].SRC || {}).id || null;
            const titel: string = structures[key].TITEL || null;

            if (!basis_katalog || !entity || !titel || disabled.indexOf(key) !== -1) {
                return;
            }
            this.basisKatalog.push({ entity, titel });
        });
        this.basisKatalog
            .sort((a: any, b: any) => a.titel > b.titel ? 1 : (a.titel < b.titel ? -1 : 0))
            .map((katalog: any, index: number) => {
                 this.tabRoutings.push({
                    path: {
                        ...RoutingIDs.ROUTE_DATENVERWALTUNG_KATALOGE, hasSubs: false,
                        [RoutingIDs.TABS_DATENVERWALTUNG_KATALOGE]: index,
                        terminateOn: RoutingIDs.TABS_DATENVERWALTUNG_KATALOGE
                    }
                 });
                this.tabs.push('kataloge');
            });
    }

    setTabIndex(tabIndex: number, tabRouting: any, callback?: () => void): void {
        if (this.state.tabIndex !== tabIndex) {
            setTimeout(() => {
                this.setState({ tabIndex }, () => {
                    this.props.onRoutingChange(tabRouting);
                    this.contextService.set(this.tabIndex, tabIndex);

                    if (typeof callback === 'function') {
                        callback();
                    }
                });
            });
        }
    }

    setTabStyle(index: number, id: string, ref: any): void {
        if (!ref) {
            return;
        }
        const style: any = (ref.node || {}).style || {};
        let backgroundColor: string = null;

        if (this.notice.indexOf(id) !== -1) {
            backgroundColor = this.state.tabIndex === index ? '#ffa' : '#ff0'
        } else if (this.warning.indexOf(id) !== -1) {
            backgroundColor = this.state.tabIndex === index ? '#fcc' : '#faa'
        }

        if (backgroundColor) {
            style.setProperty('background-color', backgroundColor, 'important');
            style.setProperty('border-color', backgroundColor, 'important');
        }
    }
}
